import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initScrollRestoration } from './utils/scrollRestoration'

// Initialize scroll restoration and navigation coordinator
initScrollRestoration();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
